import { getBooleanFeatureFlag } from '@atlassian/jira-portfolio-3-common/src/feature-flags';

const isPlatformTeamsSiteScopedM1Enabled = () =>
	getBooleanFeatureFlag('platform.teams.site-scoped.m1', false, true);

export default isPlatformTeamsSiteScopedM1Enabled;
